// Core
import Vue from 'vue';
import VueCroppie from 'vue-croppie';
import Notifications from 'vue-notification';
import VueMeta from 'vue-meta';

import App from './App';

Vue.use(VueCroppie);
Vue.use(Notifications);
Vue.use(VueMeta);

// Dependencies
import axios from 'axios';
import { store } from './stores';
import { router } from './router';
import 'croppie/croppie.css';

// Utils
import { Cookie } from './utils';

// Global Components
import './components';



if (Cookie.get(process.env.ACCESS_TOKEN) !== null)
{
    axios.defaults.headers.common.Authorization = `Bearer ${Cookie.get(process.env.ACCESS_TOKEN)}`;

    store.dispatch('auth/getUser');
}

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js